// 前端配置文件
const config = {
  // API配置
  api: {
    // 开发环境
    development: {
      // 想让本地前端连线上函数（或别的后端）时，用环境变量覆盖，不用改代码：
      // REACT_APP_API_BASE=https://buka-template-xhigfktnyr.cn-hangzhou.fcapp.run/api/v1/legacy npm start
      baseURL: process.env.REACT_APP_API_BASE || 'http://localhost:7001/template',
      timeout: 30000
    },
    // 生产环境
  production: {
    baseURL: "https://buka-template-xhigfktnyr.cn-hangzhou.fcapp.run/api/v1/legacy",
    // 多地部署的候选端点（内地 / 香港）。浏览器首次访问时并发探测，谁快用谁，
    // 结果缓存 7 天；详见 src/api-endpoint.js。
    baseURLCandidates: [
      "https://api.soda.hibuka.com/api/v1/legacy",
      "https://buka-template-xhigfktnyr.cn-hangzhou.fcapp.run/api/v1/legacy",
    ],
    timeout: 30000
  }
  },
  
  // 应用配置
  app: {
    name: 'Project Generator',
    version: '1.0.0',
    icp: '浙ICP备2025197210号',
    icpUrl: 'https://beian.miit.gov.cn/',
    github: {
      url: 'https://github.com/hibuka-labs/soda-core',
      name: 'soda-core',
      description: 'Simple Object-Oriented Domain-Driven Design Architecture'
    }
  },
  
  // 模板配置
  templates: {
    default: 'base',
    available: [
      { id: 'base', name: '基础模板', description: 'Spring Boot 基础项目模板' },
      { id: 'web-service', name: 'Web服务模板', description: '包含RESTful API的Web服务模板' },
      { id: 'microservice', name: '微服务模板', description: '微服务架构项目模板' }
    ]
  }
};

// 根据环境返回配置
const getConfig = () => {
  const env = process.env.NODE_ENV || 'development';
  return {
    ...config,
    api: config.api[env] || config.api.development
  };
};

export default getConfig(); 